import { useMutation } from "@tanstack/react-query";
import { putUserInfo } from "../api/admin";

const usePutUserInfo = () => {
  const mutation = useMutation({ mutationFn: putUserInfo });
  return mutation;
};

export default usePutUserInfo;
